/* =====
Mobile menu: measure where the header ends so the menu opens below it
===== */
(function () {
  const root = document.documentElement;

  function setMenuTop() {
    const header = document.querySelector('.wt-header');
    if (!header) return;
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    root.style.setProperty('--soroka-menu-top', bottom + 'px');
  }

  // Measure the moment the menu opens
  new MutationObserver(function () {
    if (document.body.classList.contains('menu-open')) setMenuTop();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Re-measure if the screen rotates or resizes while open
  window.addEventListener('resize', function () {
    if (document.body.classList.contains('menu-open')) setMenuTop();
  });
})();